var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalSuccessful(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_880_354)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5,
    cy: 65.5,
    rx: 61.5,
    ry: 62.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 4C97.1 4 124 30.9 124 64C124 97.1 97.1 124 64 124C30.9 124 4 97.1 4 64C4 30.9 30.9 4 64 4ZM64 0C28.7 0 0 28.7 0 64C0 99.3 28.7 128 64 128C99.3 128 128 99.3 128 64C128 28.7 99.3 0 64 0Z",
    fill: "#3A98FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5001 66.5001L86.1001 36.0001C90.8001 31.3001 98.4001 31.3001 103.1 36.0001C107.8 40.7001 107.8 48.3001 103.1 53.0001C90.0001 66.0001 77.0001 79.0001 64.0001 92.0001C59.5001 96.5001 52.4001 96.7001 47.7001 92.6001C47.5001 92.4001 47.2001 92.3001 47.0001 92.0001L25.0001 69.8001C20.3001 65.1001 20.3001 57.5001 25.0001 52.8001C29.7001 48.1001 37.3001 48.1001 42.0001 52.8001L55.5001 66.5001ZM55.5001 72.2001L39.1001 55.7001C36.0001 52.6001 30.9001 52.6001 27.8001 55.7001C24.7001 58.8001 24.7001 63.9001 27.8001 67.0001L49.8001 89.2001V89.1001C52.9001 92.2001 58.0001 92.2001 61.1001 89.1001C91.0001 59.4001 70.4001 80.0001 100.2 50.1001C103.3 47.0001 103.3 41.9001 100.2 38.8001C97.1001 35.7001 92.0001 35.7001 88.9001 38.8001L55.5001 72.2001Z",
    fill: "#3A98FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5001 72.2001L88.9001 38.8001C92.0001 35.7001 97.1001 35.7001 100.2 38.8001C103.3 41.9001 103.3 47.0001 100.2 50.1001C70.4001 80.0001 91.0001 59.4001 61.1001 89.2001C58.0001 92.3001 52.9001 92.3001 49.8001 89.2001V89.3001L27.8001 67.1001C24.7001 64.0001 24.7001 58.9001 27.8001 55.8001C30.9001 52.7001 36.0001 52.7001 39.1001 55.8001L55.5001 72.2001Z",
    fill: "#FFA502"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_880_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccessful);
export default __webpack_public_path__ + "static/media/ModalSuccessful.cd28b093413c3028a6d43e5791b6ed73.svg";
export { ForwardRef as ReactComponent };